export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7108.829b8ed4.jpg";